'use strict';

wbApp.controller('ActivityAttendanceCtrl', ['$scope', '$filter', '$modal', '$translate', '$q' ,'activityAttendanceSvc',
function ($scope, $filter, $modal, $translate, $q, activityAttendanceSvc) {
    

    $scope.tabs = [
        {
            title: 'TXT_TAB_ACTIVITY_SELECTION',
            template: 'activity-attendance/activity-selection-tab.html'
        },
        {
            title: 'TXT_TAB_DAY_SELECTION',
            template: 'activity-attendance/day-selection-tab.html'
        },
        {
            title: 'TXT_TAB_ATTENDANCE',
            template: 'activity-attendance/attendance-edit-tab.html'
        }]

    $scope.tabs.activeTab = 0;


    $scope.activities = activities;
    $scope.activitySchedules = activitySchedules;
    $scope.scheduleMonths = [];
    $scope.selectedMonth = null;
    $scope.semesterID = semesterID;
    $scope.attendanceChanged = false;

    function setSelectedActivityImpl(activity) {
        $scope.scheduleMonths = activityAttendanceSvc.filterAndBreakByMonth($scope.activitySchedules, activity.activityID);
        selectToday($scope.scheduleMonths);
        $scope.selectedActivity = activity;
    }

    $scope.setSelectedActivity = function (activity) {
        setSelectedActivityImpl(activity);
        $scope.tabs.activeTab += 1;
    }

    $scope.setSelectedSchedule = function (schedule) {
        $scope.selectedSchedule = schedule;
        $scope.attendances = activityAttendanceSvc.getAttendancesBySchedule(schedule);
        $scope.tabs.activeTab += 1;
    }

    // TODO: $index is wrong
    $scope.onAttendaceConfirmClicked = function (attendance) {
        var oldConfirmed = !attendance.confirmed;

        var index = _.findIndex($scope.attendances, { 'studentID': attendance.studentID });

        activityAttendanceSvc.saveAttendanceAsync(attendance, false).$promise
            .then(function (data) {
                // success
                $scope.attendanceChanged = true;                
                $scope.attendances[index] = data[0];
            }, function (error) {
                // revert to previous state
                attendance.confirmed = oldConfirmed;
            });

    }

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        switch (newValue) {
            case 1:
                onDaySelectionTabShow();
                break;
        }
    });

    function selectToday(months) {
        if (!months || !months.length) {
            $scope.selectedMonth = null;
            $scope.selectedSchedule = null;
            return;
        }

        var month = null;
        var schedule = null;
        var today = moment();
        for (var m = 0; m < months.length; m++) {
            month = months[m];
            var mStartDay = moment(month.startDate);
            if (mStartDay.year() >= today.year() &&
                mStartDay.month() >= today.month()) {
                for (var s = 0; s < month.schedules.length; s++) {
                    schedule = month.schedules[s];
                    var sStartDate = moment(schedule.startDate);
                    if (sStartDate.date() >= today.date()) {
                        $scope.selectedMonth = month;
                        month.expanded = true;
                        $scope.selectedSchedule = schedule;
                        $scope.attendances = activityAttendanceSvc.getAttendancesBySchedule(schedule);
                        return;
                    }
                }
            }
        }

        month = months[months.length - 1];
        if (!month.schedules.length) {
            return;
        }
        month.expanded = true;
        schedule = month.schedules[month.schedules.length - 1];

        $scope.selectedMonth = month;
        $scope.selectedSchedule = schedule;
        $scope.attendances = activityAttendanceSvc.getAttendancesBySchedule(schedule);
    }

    function setSelectedActivityByNewActivities(activities, oldSelectedActivity) {

        if (!oldSelectedActivity) {
            return;
        }

        for (var i = 0; i < activities.length; i++) {
            var activity = activities[i];
            if (activity.activityID === oldSelectedActivity.activityID) {
                $scope.selectedActivity = activity;
            }
        }
    }

    function setSelectedActivityScheduleByNewSchedules(schedules, oldSelectedSchedule) {
        if (!oldSelectedSchedule) {
            return;
        }

        for (var i = 0; i < schedules.length; i++) {
            var schedule = schedules[i];
            if (schedule.activityScheduleID === oldSelectedSchedule.activityScheduleID) {
                $scope.selectedSchedule = schedule;
            }
        }
    }

    function setSelectedMonthBynewActivities(months, selectedMonth) {
        if (!selectedMonth) {
            return;
        }

        for (var i = 0; i < months.length; i++) {
            var month = months[i];
            if (moment(month.startDate).isSame(moment(selectedMonth.startDate))) {
                $scope.selectedMonth = month;
                month.expanded = true;
            }
        }
    }

    function onDaySelectionTabShow() {
        if ($scope.attendanceChanged) {
            
            var a = activityAttendanceSvc.getActivitySchedules($scope.semesterID);
            a.$promise.then(function (data) {
                $scope.activities = data.activities;
                $scope.activitySchedules = data.activitySchedules;

                var months = activityAttendanceSvc.filterAndBreakByMonth($scope.activitySchedules, $scope.selectedActivity.activityID);

                if (months.length === $scope.scheduleMonths.length) {
                    for (var m = 0; m < months.length; m++) {
                        var newMonth = months[m];
                        var oldMonth = $scope.scheduleMonths[m];

                        oldMonth.schedules.length = 0;
                        oldMonth.schedules.push.apply(oldMonth.schedules, newMonth.schedules);
                    }
                } else {
                    $scope.scheduleMonths = months;
                }
                
                setSelectedActivityByNewActivities($scope.activities, $scope.selectedActivity);
                setSelectedMonthBynewActivities(months, $scope.selectedMonth);
                setSelectedActivityScheduleByNewSchedules($scope.activitySchedules, $scope.selectedSchedule);

            });
            $scope.attendanceChanged = false;
        }
    }

    $scope.setSelectedMonth = function (month) {
        $scope.selectedMonth = month;
        month.expanded = !month.expanded;
    }

    $scope.noteChangeModal = { title: "", saved: false };

    $scope.editDayNote = function (schedule) {
        $scope.noteChangeModal.schedule = schedule;
        $scope.noteChangeModal.lessonNote = schedule.notes;

        noteChangeModalPromise.$promise.then(function () {
            noteChangeModalPromise.show();
        });
    }

    $scope.showWaitQueue = function (schedule, activity) {
        waitQueueModalPromise.$promise.then(function () {
            waitQueueModalPromise.$scope.schedule = schedule;
            waitQueueModalPromise.$scope.activity = activity;
            waitQueueModalPromise.show();
        });
        
    }

    $scope.onLessonNoteChange = function (schedule, lessonNote, sendNotification) {
        var res = activityAttendanceSvc.updateScheduleNotesAsync(schedule.activityScheduleID, lessonNote, sendNotification);
        res.$promise.then(function () {
            schedule.notes = lessonNote;
        });
    }

    $scope.onAddBtnClick = function () {
        $scope.addStudentModal = { studentID: null };

        addStudentModalPromise.$promise.then(function () {
            addStudentModalPromise.show();
        });
    }

    $scope.onAddStudent = function (studentID) {
        if ($scope.selectedSchedule) {
            activityAttendanceSvc.addNewStudent($scope.attendances, $scope.selectedSchedule, studentID);
        }
    }

    $scope.onPrevBtnClick = function () {
        if ($scope.tabs.activeTab > 0) {
            $scope.tabs.activeTab--;
        } else {
            $scope.tabs.activeTab = 0;
        }
    }

    $scope.onDoneBtnClick = function () {

        var promisses = [];

        for (var i = 0; i < $scope.attendances.length; i++) {
            var a = $scope.attendances[i];

            if (a.isDirty) {
                var p = activityAttendanceSvc.saveAttendanceAsync(a, false).$promise;
                promisses.push(p);

                p.then(function (data) {
                    // success
                    $scope.attendanceChanged = true;
                    $scope.attendances[i] = data;
                });
            }
        }

        $q.all(promisses).then(function () {
            $scope.onPrevBtnClick();
        });
    }

    $scope.onNextBtnClick = function () {
        if ($scope.tabs.activeTab < ($scope.tabs.length - 1)) {
            $scope.tabs.activeTab++;
        } else {
            $scope.tabs.activeTab = ($scope.tabs.length - 1);
        }
    }

    $scope.onDeleteAttendanceClick = function (attendance) {
        if (!attendance.canBeDeletedWithoutConfirmation) {            
            confirmDeletePromise.$promise.then(function () {
                $scope.attendanceToBeDeleted = attendance;
                $scope.attendanceToBeDeletedMessage = 
                    $translate.instant('TXT_CONFIRM_DELETE_STUDENT_ATTENDANCE').f(attendance.studentFullName);
                confirmDeletePromise.show();
            });
        } else {
            activityAttendanceSvc.deleteAttendanceAsync($scope.attendances, attendance);

        }
    }


    $scope.onConfirmAttendanceDeleteClick = function (attendance) {
        activityAttendanceSvc.deleteAttendanceAsync($scope.attendances, attendance);
        $scope.attendanceChanged = true;
    }

    var noteChangeModalPromise = $modal({
        templateUrl: 'activity-attendance/edit-lesson-note.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    var addStudentModalPromise = $modal({
        templateUrl: 'activity-attendance/add-student-detail.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    var confirmDeletePromise = $modal({
        templateUrl: 'activity-attendance/attendance-confirm-delete.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    var waitQueueModalPromise = $modal({
        templateUrl: 'activity-attendance/wait-queue-detail.html',
        show: false,
        backdrop: true,
        scope: $scope.$new()
    });

    // pre-select first activity
    if ($scope.activities.length > 0) {
        var filtered = $filter('orderBy')($scope.activities, 'name');
        setSelectedActivityImpl(filtered[0]);
    }

}]);